import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IStudentClassListItemDTO } from '@app/infrastructure/models/student-classroom';
import { ITeacherClassListItemDTO } from '@app/infrastructure/models/teacher-classroom';

@Component({
  selector: 'app-grading-root',
  template: `
    <app-shared-classroom-list
      [headerText]="headerText"
      [classroomList]="classroomList"
    ></app-shared-classroom-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClassroomViewComponent {
  public headerText: string = 'Select a class';
  public classroomList: ITeacherClassListItemDTO[];
  constructor(private activatedRoute: ActivatedRoute) {
    this.classroomList = this.activatedRoute.snapshot.data.classroomList;
  }
}
